import Vue from 'vue'
import Vuex from 'vuex'
import administrator from './administrator'
import appConfig from '../config'
import comment from './comment'
import community from './community'
import config from './config'
import dashboard from './dashboard'
import image from './image'
import interest from './interest'
import joinRequest from './joinRequest'
import language from './language'
import locale from './locale'
import metadatas from './metadatas'
import notification from './notification'
import ownerRequest from './ownerRequest'
import post from './post'
import route from './route'
import search from './search'
import security from './security'
import skill from './skill'
import user from './user'
import userLikes from './userLikes'
import users from './users'
import atInternet from './atInternet'

Vue.use(Vuex)

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

const modules = {
  administrator,
  comment,
  community,
  config,
  dashboard,
  image,
  interest,
  joinRequest,
  language,
  locale,
  metadatas,
  notification,
  ownerRequest,
  post,
  route,
  search,
  security,
  skill,
  user,
  userLikes,
  users,
  atInternet
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules,
  strict: appConfig.ENV_NAME !== 'prod'
})
